import { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import axios from "axios";

// Whether the signed-in user is a Super Admin (role_id 1 or role_name
// "Super Admin"), by the same check as EnrollmentPauseDashboardPage. false
// while the roles load or when the lookup fails.
//
// Temporary UI gate (2026-10-24, narrowed 2026-10-27): only Super Admins see
// an event's Registration questions tab. Event Type and the Schedule tab are
// for everyone with the events page. The server does not enforce it.
export function useEventsSuperAdmin() {
  const userId = useSelector(
    (state) => state.auth.user && state.auth.user[0].user_id,
    shallowEqual
  );
  // Sent explicitly: after a hard refresh axios.defaults has no x-auth-token
  // until the rehydrate saga resolves.
  const authToken = useSelector((state) => state.auth.authToken, shallowEqual);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);

  useEffect(() => {
    if (!userId || !authToken) return undefined;
    let cancelled = false;
    axios
      .get("api/user/role/" + userId, { headers: { "x-auth-token": authToken } })
      .then((res) => {
        if (cancelled) return;
        setIsSuperAdmin(
          (res.data || []).some((r) => r.role_id === 1 || r.role_name === "Super Admin")
        );
      })
      .catch(() => {
        if (!cancelled) setIsSuperAdmin(false);
      });
    return () => {
      cancelled = true;
    };
  }, [userId, authToken]);

  return isSuperAdmin;
}
